import {getCurrentAccountFromURL} from '@lib/accounts/getCurrentAccountFromURL';
import {ActiveAccountNumber} from '@lib/accounts/types';

function currentLocationHrefForAccount(): string {
  if(typeof window !== 'undefined' && window.location?.href) {
    return window.location.href;
  }

  if(typeof location !== 'undefined' && location.href) {
    return location.href;
  }

  // `new URL('')` throws; still parseable, yields default account via getValidatedAccount
  return 'http://_/';
}

export const getCurrentAccount = (() => {
  let result: ActiveAccountNumber;
  return () => (result ??= getCurrentAccountFromURL(currentLocationHrefForAccount()));
})();
